export default __webpack_public_path__ + "static/media/Logo_KR_Intro2.8abf40b1.png";